<template>
    <section class="rules-card px-0" loading="lazy">
        <div class="rules-card-header">
            <h1>{{$t('rules', 'Rules')}}</h1>
        </div>
        <div class="container-fluid px-2">
            <div class="rules-card-body">
                <div>
                    <template v-for="(rule, r_index, rule_num) in siteRuleData" :key="r_index">
                        <template v-if="r_index == 'General'">                            
                            <div class="menu-details-list all-rule" v-html="rule"></div>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </section>
    <!-- Back to top button -->
    <div class="scroll-move-to-top-btn">
        <div class="contentDiv" id="content">
            <button class="back-to-top" :class="{show: scrollHeight}" type="button" @click="scrollToTop()"></button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Rules',
    data() {
        return{
            siteRuleData: null,
            loading:false,
            scrollHeight: window.scrollY,
        }
    },
    mounted(){
        this.getRules();
        window.addEventListener('scroll', this.handleScroll);
    },
    methods:{
        getRules() {
            this.loading = true;
            this.$store.dispatch('setGlobalLoader', true);
            if(this.siteRuleData) {
                return;
            }
            let ruleResp = this.$siteSettings?.data?.rules;
            this.siteRuleData = {}
            ruleResp?.forEach(item => {
                this.siteRuleData[item.type] = item.content;
            })  
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        handleScroll() {
            this.scrollHeight = window.scrollY > 200;
        },
    }
}
</script>